import React, {
    useState,
    useRef,
    useCallback,
    useEffect,
    useMemo,
    Fragment
} from 'react';
import { Input, InputNumber, Radio, Checkbox, Row, Col, Form, Select, TimePicker } from 'antd';
import { Option } from 'rc-select';
import { injectIntl } from "react-intl";
import './cron.less';
import moment from 'moment';
import { on_change } from "../../../../shared-functions/on-change";
import { FormInstance } from 'antd/lib/form';
import { backup_management_fields_type } from '../backup/backup.operation';

/** *CRON表达式生成器 *@author Shellcoochi */
export interface frequency_type {
    minute: any,
    hour: any,
    day: any,
    month: any,
    week: any
};

export interface cron_type {
    intl: any;
    item_selected: any;
    cron_text: string,
    set_cron_text: React.Dispatch<React.SetStateAction<string>>,
    set_disabled: React.Dispatch<React.SetStateAction<boolean>>,
    form?: FormInstance<backup_management_fields_type>
}

const Cron: React.FC<cron_type> = (props: cron_type) => {

    const { cron_text, set_cron_text, item_selected, set_disabled, form }: cron_type = useMemo((): any => props, [props]);

    const { formatMessage } = useMemo(() => props.intl, [props]);
    const [selected_type, set_selected_type]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("");
    const [default_time, set_default_time]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("");
    const [default_checkValue, set_default_checkValue]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([]);
    const [default_interval, set_default_interval]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(0);
    const [default_loop_start, set_default_loop_start]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("");
    const [default_loop_end, set_default_loop_end]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("");

    // frequency 选项列表
    const frequency_list: React.MutableRefObject<{ key: string, value: string }[]> = useRef([
        // { key: "0", value: "minute" },
        { key: "1", value: "hour" },
        { key: "2", value: "day" },
        { key: "3", value: "month" },
        { key: "4", value: "week" }
    ]);
    // const [cron_text, set_cron_text]: [string, React.Dispatch<React.SetStateAction<string>>] = useContext(CronTextContext);
    // point period loop
    const [radioValue, set_radioValue]: [frequency_type, React.Dispatch<React.SetStateAction<frequency_type>>] = useState<frequency_type>({
        minute: 1,
        hour: 1,
        day: 1,
        month: 1,
        week: 1
    });
    const [periodValue, set_periodValue]: [frequency_type, React.Dispatch<React.SetStateAction<frequency_type>>] = useState<frequency_type>({
        minute: { max: 0, min: -1 },
        hour: { max: 0, min: -1 },
        day: { max: 0, min: -1 },
        month: { max: 0, min: -1 },
        week: { max: 0, min: -1 }
    });
    const [loopValue, set_loopValue]: [frequency_type, React.Dispatch<React.SetStateAction<frequency_type>>] = useState<frequency_type>({
        minute: { start: -1, interval: 1, end: 0 },
        hour: { start: -1, interval: 1, end: 0 },
        day: { start: -1, interval: 1, end: 0 },
        month: { start: -1, interval: 1, end: 0 },
        week: { start: -1, interval: 1, end: 0 }
    });
    // eslint-disable-next-line
    const [cron, set_cron]: [frequency_type, React.Dispatch<React.SetStateAction<frequency_type>>] = useState<frequency_type>({
        minute: '*', hour: '*', day: '*', month: '*', week: '*'
    });
    const [cronParams, set_cronParams]: [frequency_type, React.Dispatch<React.SetStateAction<frequency_type>>] = useState<frequency_type>({
        minute: '*', hour: '*', day: '*', month: '*', week: '*'
    });
    const cronType: React.MutableRefObject<string[]> = useRef(['minute', 'hour', 'day', 'month', 'week']);
    const monthOptions = useRef([
        { key: "1", value: "Jan" },
        { key: "2", value: "Feb" },
        { key: "3", value: "Mar" },
        { key: "4", value: "Apr" },
        { key: "5", value: "May" },
        { key: "6", value: "Jun" },
        { key: "7", value: "Jul" },
        { key: "8", value: "Aug" },
        { key: "9", value: "Sep" },
        { key: "10", value: "Oct" },
        { key: "11", value: "Nov" },
        { key: "12", value: "Dec" }]);
    const weekOptions = useRef([
        { key: "0", value: "Sun" },
        { key: "1", value: "Mon" },
        { key: "2", value: "Tue" },
        { key: "3", value: "Wed" },
        { key: "4", value: "Thu" },
        { key: "5", value: "Fri" },
        { key: "6", value: "Sat" }]);

    const radioStyle = useRef({
        display: 'flex',
        height: '30px',
        lineHeight: '30px',
        width: "100%",
        marginBottom: "15px"
    });

    /**
     * 对象生成器
     * @param type
     * @param data
     * @returns {minute: *}}
     */
    const cronItemGenerator = useCallback((type, data) => {
        let cron_select: any = "";
        switch (type) {
            // case 'second': cron_select = { second: data }; break;
            case 'time': cron_select = data === "point" ?
                { hour: data, minute: data }
                : { hour: data[0].data, minute: data[1].data }; break;
            case 'minute': cron_select = { minute: data }; break;
            case 'hour': cron_select = { hour: data }; break;
            case 'day': cron_select = { day: data }; break;
            case 'month': cron_select = { month: data || "*" }; break;
            case 'week': cron_select = { week: data || "*" }; break;
            default: break;
        }
        return cron_select;
    }, []);

    /**
    * 格式化0~9的数字
    * @param num 
    */
    const formatNum = useCallback((num) => {
        if (num < 10 && num > -1) {
            return '0' + num;
        }
        return String(num);
    }, []);

    /**
     * 生成多选框
     * @param col 每行个数
     * @param minNum 最小值
     * @param maxNum 最大值
     * @param key
     */
    const createCheckbox = useCallback((key, col, minNum, maxNum) => {

        let colArray = [];
        let rowArray = [];
        let count = col;
        let keyNum = minNum;
        for (minNum; minNum <= maxNum; minNum++) {
            let checkbox = <Checkbox key={key + keyNum} value={String(minNum)}>{formatNum(minNum)}</Checkbox>;
            if (count > 0) {
                colArray.push(checkbox);
                count--;
                if (minNum === maxNum) rowArray.push(<Col key={key + keyNum} span={24}>{colArray}</Col>)
            } else {
                rowArray.push(<Col key={key + keyNum} span={24}>{colArray}</Col>)
                colArray = [];
                minNum--;
                count = col;
            }
            keyNum++;
        }
        return <Row className="checkbox-row">{rowArray}</Row>
    }, [formatNum]);

    const handleRadioChange = useCallback((e, type) => {
        set_radioValue(Object.assign({}, radioValue, cronItemGenerator(type, e.target.value)))
    }, [cronItemGenerator, radioValue]);

    const handleCheckChange = useCallback((checkedValues, type) => {
        let week_index: any[] = [];
        if (type === "week") {
            checkedValues.map((item: any) => {
                return week_index.push(weekOptions.current.filter(({ key }) => { return item === key })[0]?.key)
            })
        };
        set_radioValue(Object.assign({}, radioValue, cronItemGenerator(type, "point")));
        set_cronParams(Object.assign({}, cronParams, cronItemGenerator(type, type === "week" ? week_index :
            checkedValues.sort((a: string, b: string) => { return Number(a) - Number(b) }))));
    }, [cronItemGenerator, set_cronParams, radioValue, cronParams]);

    const handlePeriodChange = useCallback((e, type, tar) => {
        set_radioValue(Object.assign({}, radioValue, cronItemGenerator(type, "period")));
        let data = periodValue as any;
        data[type] = tar === 'max' ? { max: e, min: data[type].min } : { max: data[type].max, min: e };
        set_periodValue(Object.assign({}, periodValue, cronItemGenerator(type, data[type])));
    }, [cronItemGenerator, set_periodValue, periodValue, radioValue]);

    const handleLoopChange = useCallback((e, type, tar) => {
        set_radioValue(Object.assign({}, radioValue, cronItemGenerator(type, "loop")));
        let data = loopValue as any;
        data[type] = tar === 'start' ? { start: e, end: data[type].end, interval: data[type].interval } :
            tar === 'interval' ? { start: data[type].start, end: data[type].end, interval: e } :
                { start: data[type].start, end: e, interval: data[type].interval };
        set_loopValue(Object.assign({}, loopValue, cronItemGenerator(type, data[type])));
    }, [cronItemGenerator, set_loopValue, loopValue, radioValue]);

    const format_time = useCallback((time: string, index: number) => {
        return time.split(":")[index][0] === "0" ? time.split(":")[index][1] : time.split(":")[index]
    }, [])

    // cron生成器
    useEffect(() => {
        let obj_cron: frequency_type = {} as frequency_type;
        for (let type of cronType.current) {
            let srv = (radioValue as any)[type];
            let period = (periodValue as any)[type];
            let loop = (loopValue as any)[type];
            let param = (cronParams as any)[type];
            let data = '';
            // console.log("srv param ", srv, period, loop);
            switch (srv) {
                case 1: data = '*'; break;
                case 2: data = '?'; break;
                case 'point':
                    if (Array.isArray(param)) {
                        for (let v of param) {
                            data = data + v + ',';
                        }
                        data = data.substring(0, data.length - 1);
                    } else { data = param }
                    break;
                case 'period':
                    data = !period.max ? period.min : period.min + '-' + period.max;
                    break;
                case 'loop':
                    data = loop.start === -1 ? '*/' + loop.interval :
                        loop.end ? loop.start + '-' + loop.end + '/' + loop.interval : loop.start + '/' + loop.interval; break;
                default:
                    data = '*'; break;
            }
            obj_cron = selected_type === "hour" ? Object.assign(cron, { minute: '0' }, cronItemGenerator(type, data)) :
                Object.assign(cron, cronItemGenerator(type, data));
            // set_cron({...obj_cron});
            let { minute, hour, day, month, week } = obj_cron;
            let cronText = minute + ' ' + hour + ' ' + day + ' ' + month + ' ' + week;
            set_cron_text?.(cronText);
        }
    }, [cronItemGenerator, radioValue, periodValue, loopValue, cronParams, cron, set_cron_text, selected_type]);

    const hourCheckbox: JSX.Element = createCheckbox('hour', 8, 0, 23);

    useEffect((): void => {
        if (item_selected && Object.keys(item_selected).length && item_selected?.frequency) {
            set_cron_text(item_selected?.cron_time);
            set_selected_type(item_selected.frequency);
        } else {
            set_selected_type("hour");
            set_radioValue({ minute: 1, hour: "loop", day: 1, month: 1, week: 1 });
            set_loopValue((currentState) => ({
                ...currentState,
                hour: { start: "0", interval: 1, end: "23" }
            }));
        }
    }, [item_selected, form, set_cron_text])

    const filter_all_key = useCallback((list: any[]) => {
        let filter_list: string[] = [];
        list.map(({ key }) => {
            return filter_list.push(key);
        })
        return filter_list
    }, [])

    const initial_cron = useCallback(() => {
        set_default_checkValue([]);
        switch (form?.getFieldValue("frequency")) {
            // case "minute":
            //     set_radioValue({ minute: "loop", hour: "period", day: 1, month: 1, week: 1 });
            //     set_loopValue(Object.assign({}, loopValue, { minute: { start: -1, end: 0, interval: 1 } }));
            //     set_periodValue(Object.assign({}, periodValue, { hour: { max: "23", min: "00" } }));
            //     break;
            case "hour":
                set_radioValue({ minute: 1, hour: "loop", day: 1, month: 1, week: 1 });
                set_loopValue({
                    minute: { start: -1, interval: 1, end: 0 },
                    hour: { start: "0", interval: 1, end: "23" },
                    day: { start: -1, interval: 1, end: 0 },
                    month: { start: -1, interval: 1, end: 0 },
                    week: { start: -1, interval: 1, end: 0 }
                });
                break;
            case "day":
                set_cronParams({ hour: "0", minute: "0", day: '*', month: '*', week: '*' });
                set_radioValue({ minute: "point", hour: "point", day: "point", month: 1, week: 1 });
                break;
            case "month":
                set_cronParams({ hour: "0", minute: "0", day: '*', month: '*', week: '*' });
                set_radioValue({ minute: "point", hour: "point", month: "point", day: 1, week: 1 });
                break;
            case "week":
                set_cronParams({ hour: "0", minute: "0", day: '*', month: '*', week: '*' });
                set_radioValue({ minute: "point", hour: "point", week: "point", day: 1, month: 1 });
                break;
            default:
                break;
        }
    }, [form])

    useEffect((): void => {
        if (item_selected && item_selected.frequency === form?.getFieldValue("frequency")) {
            const { frequency, cron_time } = item_selected;
            const selected_cron = cron_time?.split(" ");
            switch (frequency) {
                // case "minute":
                //     if (selected_cron[1].includes("-")) {
                //         set_default_loop_start(selected_cron[1].split("-")[0]);
                //         set_default_loop_end(selected_cron[1].split("-")[1]);
                //         set_periodValue(Object.assign({}, periodValue, { hour: { max: selected_cron[1].split("-")[1], min: selected_cron[1].split("-")[0] } }));
                //     }
                //     set_default_interval(selected_cron[0].split("/")[1]);
                //     set_radioValue(Object.assign({}, radioValue, { minute: "loop", hour: "period" }));
                //     set_loopValue(Object.assign({}, loopValue, { minute: { start: -1, end: 0, interval: selected_cron[0].split("/")[1] } }));
                //     break;
                case "hour":
                    set_default_interval(selected_cron[1].split("/")[1]);
                    if (selected_cron[1].includes("-")) {
                        set_radioValue(Object.assign({}, radioValue, { hour: "loop" }));
                        set_default_loop_start(selected_cron[1].split("-")[0]);
                        set_default_loop_end(selected_cron[1].split("-")[1].split("/")[0]);
                        set_loopValue(Object.assign({}, loopValue, { hour: { start: selected_cron[1].split("-")[0], interval: selected_cron[1].split("/")[1], end: selected_cron[1].split("-")[1].split("/")[0] } }));
                    } else {
                        set_radioValue(Object.assign({}, radioValue, { hour: "point" }));
                        set_default_checkValue([...selected_cron[1].split(",")]);
                        set_loopValue({
                            minute: { start: -1, interval: 1, end: 0 },
                            hour: { start: "0", interval: 1, end: "23" },
                            day: { start: -1, interval: 1, end: 0 },
                            month: { start: -1, interval: 1, end: 0 },
                            week: { start: -1, interval: 1, end: 0 }
                        });
                        set_cronParams(Object.assign({}, cronParams, { hour: selected_cron[1].split(",") }));
                    }
                    break;
                case "day":
                    set_default_time(`${selected_cron[1]}:${selected_cron[0]}`);
                    set_cronParams(Object.assign({}, cronParams, { hour: selected_cron[1], minute: selected_cron[0] }));
                    set_radioValue(Object.assign({}, radioValue, { minute: "point", hour: "point", day: "point" }));
                    break;
                case "month":
                    let selected_month: string = selected_cron[selected_cron.length - 2];
                    set_default_checkValue(selected_month === "*" ? filter_all_key(monthOptions.current) : selected_cron[selected_cron.length - 2].split(","));
                    set_default_time(`${selected_cron[1]}:${selected_cron[0]}`);
                    set_cronParams(Object.assign({}, cronParams, {
                        hour: selected_cron[1],
                        minute: selected_cron[0],
                        month: selected_month === "*" ? filter_all_key(monthOptions.current) : selected_cron[selected_cron.length - 2].split(",")
                    }));
                    set_radioValue(Object.assign({}, radioValue, { minute: "point", hour: "point", month: "point" }));
                    break;
                case "week":
                    let selected_week: string = selected_cron[selected_cron.length - 1];
                    set_default_checkValue(selected_week === "*" ? filter_all_key(weekOptions.current) : selected_cron[selected_cron.length - 1].split(","));
                    set_default_time(`${selected_cron[1]}:${selected_cron[0]}`);
                    set_cronParams(Object.assign({}, cronParams,
                        {
                            hour: selected_cron[1],
                            minute: selected_cron[0],
                            week: selected_week === "*" ? filter_all_key(weekOptions.current) : selected_cron[selected_cron.length - 1].split(",")
                        }));
                    set_radioValue(Object.assign({}, radioValue, { minute: "point", hour: "point", week: "point" }));
                    break;
                default:
                    break;
            }
        } else {
            initial_cron();
        }
        // eslint-disable-next-line
    }, [item_selected, initial_cron, form])

    // frequency 为 week / month 时的指定时间元素
    const every_level = useCallback((list: any[], type: string) => {
        // rules={[{ required: true, message: `${formatMessage({ id: type })} is required.` }]}
        return <Form.Item label={formatMessage({ id: "specify" })} key={type} name={type}>
            <Select
                mode="multiple"
                allowClear
                autoFocus={true}
                style={{ marginLeft: "5px", width: "100%" }}
                placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: type === "week" ? type : `cron_${type}` }).toLowerCase()}` })}
                defaultValue={default_checkValue ? default_checkValue : undefined}
                onChange={(e) => {
                    handleCheckChange(e, type);
                    on_change(form, set_disabled);
                }}
            >
                {list?.length && list.map((item, index) => (
                    <Option key={`${type}_${index}`} value={item.key}>
                        {formatMessage({ id: item.value })}
                    </Option>
                ))}
            </Select>
        </Form.Item>
    }, [handleCheckChange, default_checkValue, formatMessage, form, set_disabled])

    const period_min_max = useCallback((key: string, type: string, level: string) => {
        let period = (periodValue as any)[type];
        return <Col>
            <span className="mr-5">{formatMessage({ id: key })}</span>
            <TimePicker
                style={{ width: "100%" }}
                format="HH:mm"
                allowClear={false}
                showNow={false}
                // disabled={level === "max" && period.min === -1 && !default_loop_end}
                // placeholder={formatMessage({ id: "select_product" })}
                // defaultValue={moment(`${level === "min" && default_loop_start ? default_loop_start : level === "max" && default_loop_end ? default_loop_end : '00:00'}`, 'HH:mm')}
                defaultValue={moment(`${level === "min" ? default_loop_start ? default_loop_start : "00:00" :
                    level === "max" && default_loop_end ? default_loop_end : '23:00'}`, 'HH:mm')}
                disabledMinutes={() => {
                    let minutes = []
                    for (var i = 0; i < 60; i++) {
                        minutes.push(i)
                    }
                    return minutes
                }}
                disabledHours={() => {
                    let hours = [];
                    if (period.min !== -1) {
                        let base_hour: string = period.min.substring(0) === "0" ?
                            String(Number(period.min.substring(1)) + 1) :
                            String(Number(period.min) + 1);
                        if (period.min !== "23") {
                            for (var i = 0; i < (level === "min" ? 0 : base_hour); i++) {
                                hours.push(i)
                            }
                        } else {
                            for (var j = 23; j > 0; j--) {
                                hours.push(j)
                            }
                        }
                    }
                    return hours
                }}
                onChange={(_time: any, timeString: string) => {
                    handlePeriodChange(format_time(timeString, 0), type, level);
                    on_change(form, set_disabled);
                }}
            />
        </Col>
    }, [periodValue, handlePeriodChange, default_loop_start, default_loop_end, form, set_disabled, formatMessage, format_time])

    const loop_start_end = useCallback((key: string, type: string, level: string) => {
        let loop = (loopValue as any)[type];
        return <Col key={key}>
            <span className="mr-5">{formatMessage({ id: key })}</span>
            <TimePicker
                style={{ width: '100%' }}
                format="HH"
                allowClear={false}
                showNow={false}
                // disabled={level === "end" && loop.start === -1 && !default_loop_end}
                defaultValue={moment(`${level === "start" ? default_loop_start ? default_loop_start : "00" :
                    level === "end" && default_loop_end ? default_loop_end : '23'}`, 'HH')}
                // disabledMinutes={() => {
                //     let minutes = []
                //     for (var i = 0; i < 60; i++) {
                //         minutes.push(i)
                //     }
                //     return minutes
                // }}
                disabledHours={() => {
                    let hours = [];
                    if (loop.start !== -1) {
                        let base_hour: string = loop.start.substring(0) === "0" ?
                            String(Number(loop.start.substring(1)) + 1) :
                            String(Number(loop.start) + 1);
                        if (loop.start !== "23") {
                            for (var i = 0; i < (level === "start" ? 0 : base_hour); i++) {
                                hours.push(i)
                            }
                        } else {
                            for (var j = 23; j > 0; j--) {
                                hours.push(j)
                            }
                        }
                    }
                    return level === "start" ? [] : hours
                }}
                onChange={(_time: any, timeString: string) => {
                    handleLoopChange(format_time(timeString, 0), type, level);
                    on_change(form, set_disabled);
                }}
            />
        </Col>
    }, [loopValue, handleLoopChange, default_loop_start, default_loop_end, form, set_disabled, formatMessage, format_time])

    const clock_element = useCallback((time_type: string) => {
        return <Form.Item label={formatMessage({ id: "timing_schedule" })} key={`${time_type}_time`} name={`${time_type}_time`}>
            <TimePicker
                style={{ width: '100%' }}
                format="HH:mm"
                allowClear={false}
                showNow={false}
                placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "timing_schedule" }).toLowerCase()}` })}
                defaultValue={moment(item_selected?.frequency === time_type && default_time ? default_time : "00:00", 'HH:mm')}
                onChange={(_time: any, timeString: string) => {
                    handleCheckChange([
                        { type: "hour", data: format_time(timeString, 0) },
                        { type: "minute", data: format_time(timeString, 1) }
                    ], "time");
                    on_change(form, set_disabled);
                }} />
        </Form.Item>
    }, [default_time, form, item_selected, formatMessage, format_time, handleCheckChange, set_disabled])

    // useEffect((): void => {
    //     console.log("params ", radioValue, periodValue, loopValue, cronParams)
    // }, [radioValue, periodValue, loopValue, cronParams])

    const frequency_element: JSX.Element | undefined = useMemo(() => {
        let element_data: JSX.Element | undefined = undefined;
        if (selected_type) {
            switch (selected_type) {
                case "minute":
                    element_data = <Row align="middle" justify="space-between" className="time-item">
                        {period_min_max("cron_start_time", "hour", "min")}
                        <Col>
                            <span className="mr-5">{formatMessage({ id: 'time_interval' })}</span>
                            <InputNumber size="small" min={1} max={59} defaultValue={default_interval ? default_interval : 1} onChange={e => {
                                handleLoopChange(e, 'minute', 'interval');
                                on_change(form, set_disabled);
                            }} />
                        </Col>
                        {period_min_max("cron_end_time", "hour", "max")}
                    </Row>
                    break;
                case "hour":
                    element_data = <Radio.Group
                        style={{ width: "100%" }}
                        className="hour-span"
                        onChange={e => {
                            on_change(form, set_disabled);
                            handleRadioChange(e, 'hour');
                        }}
                        value={radioValue['hour']}>
                        <Radio style={radioStyle.current} value='loop'>
                            <Form.Item
                                style={{ marginTop: "-2px" }}
                                name="time_loop"
                                rules={[{
                                    validator(_rule: any, value: string) {
                                        return (Number(loopValue.hour?.start) - Number(loopValue.hour?.end)) > 0
                                            ? Promise.reject(formatMessage({ id: 'time_warn' }))
                                            : Promise.resolve();
                                    }
                                }]}>
                                <Col>
                                    <Row align="middle" justify="space-between" className="time-item width-bigger">
                                        {loop_start_end("cron_start_time", "hour", "start")}
                                        <Col>
                                            <span className="mr-5">{formatMessage({ id: 'time_interval' })}</span>
                                            <InputNumber size="small" min={1} max={23} defaultValue={default_interval ? default_interval : 1} onChange={e => {
                                                handleLoopChange(e, 'hour', 'interval');
                                                on_change(form, set_disabled);
                                            }} />
                                        </Col>
                                        {loop_start_end("cron_end_time", "hour", "end")}
                                    </Row>
                                    {/* {loop_warn && <Row className="hour_warn_row">{formatMessage({ id: "time_warn" })}</Row>} */}
                                </Col>
                            </Form.Item>
                        </Radio>
                        <Radio style={radioStyle.current} value='point'>
                            <Checkbox.Group
                                style={{ width: '100%' }}
                                defaultValue={default_checkValue ? default_checkValue : undefined}
                                onChange={e => { handleCheckChange(e, 'hour'); on_change(form, set_disabled); }}>
                                <span className="mb-10 d-inline">{formatMessage({ id: 'specify' })}</span>
                                {hourCheckbox}
                            </Checkbox.Group>
                        </Radio>
                    </Radio.Group>
                    break;
                case "day":
                    element_data = clock_element("day");
                    break;
                case "month":
                    element_data = <Fragment>
                        {every_level(monthOptions.current, "month")}
                        {clock_element("month")}
                    </Fragment>
                    break;
                case "week":
                    element_data = <Fragment>
                        {every_level(weekOptions.current, "week")}
                        {clock_element("week")}
                    </Fragment>
                    break;
                default:
                    break;
            }
            return element_data
        } else return undefined
    }, [clock_element, loopValue, formatMessage, default_checkValue, default_interval, selected_type, radioValue, every_level, handleCheckChange, handleLoopChange, handleRadioChange, hourCheckbox, loop_start_end, period_min_max, radioStyle, form, set_disabled]);

    return (
        <Col className="cron">
            <Form.Item label={formatMessage({ id: "frequency" })} key="frequency" name="frequency" rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]}>
                <Select
                    showSearch
                    value={selected_type}
                    style={{ width: '100%' }}
                    placeholder={`${formatMessage({ id: "select_product" })} ${formatMessage({ id: "frequency" })}`}
                    onChange={(e: any) => {
                        e === "hour" && set_radioValue((current_state: frequency_type) => ({
                            ...current_state,
                            minute: 1,
                            hour: "point",
                        }))
                        set_default_checkValue([]);
                        set_selected_type(e);
                        set_cronParams({ minute: '*', hour: '*', day: '*', month: '*', week: '*' });
                        set_cron_text("* * * * *");
                        sessionStorage.setItem('selected_frequency', e);
                        on_change(form, set_disabled);
                        initial_cron();
                        form?.setFieldsValue({
                            day_time: moment("00:00", "HH:mm"),
                            month_time: moment("00:00", "HH:mm"),
                            week_time: moment("00:00", "HH:mm"),
                            month: undefined,
                            week: undefined
                        });
                    }}
                >
                    {frequency_list?.current?.map(({ key, value }) => {
                        return (
                            <Option value={value} key={key}>
                                {value}
                            </Option>
                        );
                    })}
                </Select>
            </Form.Item>

            <Col className={`cron-param ${(selected_type === "minute" || selected_type === "hour") && "format-width"} ${selected_type === "hour" && "checkbox-height"}`}>
                {frequency_element}
            </Col>
            {/* key="cron" name="cron" rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]} */}
            <Form.Item className="cron_input" label={formatMessage({ id: "cron" })}>
                <Input disabled style={{ width: "100%" }} value={cron_text} />
            </Form.Item>
        </Col>
    )
}

export default injectIntl(Cron);